let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jK12s")).then(() => parcelRequire('dR5Vp'));